const words = (s) => String(s || "").split(/\s+/).filter(Boolean).length;
const len = (a) => (a || []).length;

// Mirrors backend/quality.py
const CHECKS = [
  ["Product overview (400+ words)", (d) => words(d.overview) >= 400],
  ["Key features (5+)", (d) => len(d.key_features) >= 5],
  ["Advantages (3+)", (d) => len(d.pros) >= 3],
  ["Disadvantages (2+)", (d) => len(d.cons) >= 2],
  ["Ideal users (2+)", (d) => len(d.ideal_users) >= 2],
  ["Practical use cases (2+)", (d) => len(d.best_use_cases) >= 2],
  ["Integrations (1+)", (d) => len(d.integrations) >= 1],
  ["Limitations (2+)", (d) => len(d.limitations) >= 2],
  ["Alternatives (1+)", (d) => len(d.alternatives) >= 1],
  ["FAQs (3+)", (d) => len(d.faqs) >= 3],
  ["Editorial conclusion (80+ words)", (d) => words(d.conclusion) >= 80],
  ["Pricing information", (d) => !!d.pricing_model && !!d.pricing_summary],
  ["Official website", (d) => !!d.website_url],
];
const VERIFY = [
  ["Official sources recorded", (d) => len(d.sources) >= 1],
  ["Fact-check date", (d) => !!d.facts_checked_at],
];

export function reviewQuality(d) {
  const missing = CHECKS.filter(([, ok]) => !ok(d)).map(([l]) => l);
  const unverified = VERIFY.filter(([, ok]) => !ok(d)).map(([l]) => l);
  return { status: missing.length ? "incomplete" : unverified.length ? "needs_verification" : "complete", missing: [...missing, ...unverified] };
}

export const QUALITY_LABEL = { complete: "Complete", needs_verification: "Needs verification", incomplete: "Incomplete" };
export const QUALITY_CLS = {
  complete: "bg-[#ECF6F4] text-[#0F766E] border-[#BFE0DB]",
  needs_verification: "bg-amber-50 text-amber-800 border-amber-200",
  incomplete: "bg-rose-50 text-rose-700 border-rose-200",
};
